import ReactDOM from 'react-dom';
import { NavSearchButton, NavSearchResult } from './NavSearch';

document.getElementById('search-box') && 
  ReactDOM.render(<NavSearchResult />, document.getElementById('search-box'));

document.getElementById('navsearch-btn') &&
  ReactDOM.render(<NavSearchButton />, document.getElementById('navsearch-btn'));